import React, { useContext, useState } from 'react'
import * as S from './styled'
import { LOGO_HOTAREA,DEFAULT_BANNER, HEADER_HOTAREA, STORE_IMAGES, CASHBACK_ICON } from '../../constants/urls';
import { categories } from '../../constants/jsons';
import Login from '../Login/Login';
import ModalLogin from '../Modal/Login/Login';
import { MenuItem, Select, CircularProgress } from '@mui/material';
import { useAuth } from '../../context/AuthContext';
import { StyledFormControl } from '../../styles/common/UIComponents';
import { FlexContainer } from '../../styles/common/FlexBox';
import useUserData from '../../hooks/useUserData';
import useCouponRedirect from '../../hooks/useCouponRedirect';
import useUTMParams from '../../hooks/useUTMParams';
import { useAlert } from '../../context/AlertContext';
import { CouponsContext } from '../../context/CouponsContext';
import CategoryFilter from '../Filters/CategoryFilter';
import { useSearchParams } from 'react-router-dom';
import {useMediaQuery} from '@mui/material';
import { categoryIcons } from '../../constants/Category/category-icons';
import { seasonalCategoryIcons } from '../../constants/Category/seasonal-icons';
import CategoryIcon from '@mui/icons-material/Category';
import { formatCashback } from '../Coupons/CouponCard';

const Header = (props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const type = searchParams.get("type") || '';
  
  const {coupons} = useContext(CouponsContext);
  const { hotArea = null, isStore = false } = props;
  const { isAuthenticated } = useAuth(+hotArea.incentiveId);

  const { user, loadingUser, errorUser } = useUserData()
  const { getcouponRedirect } = useCouponRedirect();
  const { utmSource, utmCampaign } = useUTMParams();
  const { showAlert } = useAlert();
  const [loadingRedirect, setLoadingRedirect] = useState(false);
  const [openLoginModal, setOpenLoginModal] = useState(false);
  const handleOpenLoginModal = () => setOpenLoginModal(true);
  const handleCloseLoginModal = () => setOpenLoginModal(false);
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [categorie, setCategorie] = React.useState('');

  const handleChange = (event) => {
    setCategorie(event.target.value);
  };

  const handleChangeType = (event) => {
    const value = event.target.value;
    if (value) {
      searchParams.set("type", value);
    } else {
      searchParams.delete("type");
    }
    setSearchParams(searchParams);
  };

  const cashback = hotArea?.cashbackPercentage ? formatCashback(hotArea.cashbackPercentage) : null;

  // Sem headerImage próprio, usa o fundo do tema ativo (src/theme)
  const hasOwnHeaderImage = !!hotArea?.headerImage;
  const headerBackground = hasOwnHeaderImage
    ? `url(${HEADER_HOTAREA}${hotArea.headerImage})`
    : "var(--c-images-header-bg)";

  const textColor = hotArea?.couponHeaderTextColor || 'ffffff'; 
  const hoverColor = hotArea?.couponHeaderColor || 'ffd700';
  const headerImage = hotArea?.navBarColor || 'ffffff';
  

  const [logoSrc, setLogoSrc] = useState(
    hotArea?.imageName ? `${LOGO_HOTAREA}${hotArea.imageName}` : `${STORE_IMAGES}${hotArea?.slug}.png`
  );
  const [logoError, setLogoError] = useState(false);
  
  const handleLogoError = (e) => {
    if (logoSrc === `${LOGO_HOTAREA}${hotArea?.imageName}`) {
      setLogoSrc(`${STORE_IMAGES}${hotArea.slug}.png`);
    } else {
      setLogoError(true);
    }
  };
  
  let IconComponent = null;

  if (hotArea?.type === "SEASONAL") {
    IconComponent = seasonalCategoryIcons[hotArea?.slug];
  } else {
    IconComponent = categoryIcons[hotArea?.slug];
  }

  const selectCategorie = categories.map((categorie) => {
    return (
        <MenuItem key={categorie.slug} value={categorie.slug}>{categorie.name}</MenuItem>
    )
  })

  const onClickActivateCashback = async () => {
    const link = hotArea.defaultOfferUrl || hotArea.deepLinkUrl;

    if (!link) {
      showAlert("Link da oferta não disponível para esta loja.", "error");
      return;
    }

    try {
      setLoadingRedirect(true);
      const trackedLink = await getcouponRedirect({
        link,
        source: utmSource,
        campaign: utmCampaign,
        userId: `${user?.id}`,
        store: hotArea.slug,
        incentive: +hotArea.incentiveId
      });

      if (!trackedLink) {
        showAlert("Link de redirecionamento não retornado.", "error");
        return;
      }

      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      if (isMobile) {
        window.location.assign(trackedLink);
      } else {
        window.open(trackedLink, "_blank", "noopener,noreferrer");
      }
    } catch (error) {
      showAlert(`Erro ao redirecionar para a loja: ${error.message}`, "error");
    } finally {
      setLoadingRedirect(false);
    }
  };

  const username = () =>
    user.name 
      ? user.name 
      : user.username 
        ? user.username 
        : user.email 
          ? user.email.split('@')[0] 
          : null;

  return (
    <S.HeaderContainerDesktop backgroundImage={headerBackground} $themedBackground={!hasOwnHeaderImage} backgroundColor={`#${headerImage}`}>
        <S.TitleMobile style={{ color: `#${hotArea.navBarTextColor}`, fontWeight: 'bold'  }}>
          {hotArea.name}
        </S.TitleMobile>

        {!logoError && logoSrc ? (
          <S.LogoWrapperBorder>
            <S.LogoWrapper>
              <S.Logo src={logoSrc} alt="Logo" onError={handleLogoError} />
            </S.LogoWrapper>
          </S.LogoWrapperBorder>
        ) : (
          <S.LogoFallback>
            {IconComponent ? (
              <IconComponent sx={{ fontSize: 100, color: 'white' }} />
            ) : (
              <CategoryIcon sx={{ fontSize: 100, color: 'white' }} />
            )}
          </S.LogoFallback>
        )}

        <FlexContainer direction="column" gap="1rem" justify="center" align="flex-start">
          <S.TitleDesktop style={{ color: `#${hotArea.navBarTextColor}`, fontWeight: 'bold' }}>
            {hotArea.name}
          </S.TitleDesktop>
          <S.H3 style={{ color: `#${hotArea.navBarTextColor}` }}>
            {hotArea.description}
          </S.H3>
          {isAuthenticated ? (
            <p style={{ color: `#${hotArea.navBarTextColor}` }}>
              Seja Bem-vindo(a), {username()}
            </p>
          ) : (
            hotArea.type === "LOYALTY" &&(
              <Login 
              name="Acessar descontos"
              showButton={true}
              color={`#${textColor}`}
              hoverColor={`#${hoverColor}`}
              border={`1px solid #${textColor}`}
              width= {isMobile ? "100%" : "80%" } 
              hotAreaName={hotArea.name} 
              longDescription={hotArea.longDescription}
              logo={`${LOGO_HOTAREA}${hotArea.imageName}`}
              incentiveId={hotArea.incentive_id}
              slug={hotArea?.slug}
              ></Login>
            ))}
            {/* --- BLOCO DO CASHBACK --- */}
              {isStore && (
              <S.CashbackContainer>
                {!!hotArea?.cashbackOn && (
                  <div>
                    <S.CashbackInfo>
                      <img
                        src={CASHBACK_ICON}
                        alt="Carteira"
                        width={52}
                        height={52}
                      />
                      <div>
                        <S.CashbackText>{cashback} de cashback</S.CashbackText>
                        <S.MoreInfoLink href="/devolve" target="_blank">
                          Saiba mais
                        </S.MoreInfoLink>
                      </div>
                    </S.CashbackInfo>
                  </div>
                )}

                {!!hotArea?.cashbackOn ? (
                  isAuthenticated ? (
                    <S.ActivateButton onClick={onClickActivateCashback} disabled={loadingRedirect}>
                      {loadingRedirect ? (
                        <CircularProgress size={18} color="inherit" />
                      ) : (
                        "Ativar Cashback e ir para a loja"
                      )}
                    </S.ActivateButton>
                  ) : (
                    <S.ActivateButton onClick={handleOpenLoginModal}>
                      Ativar Cashback e ir para a loja
                    </S.ActivateButton>
                  )
                ) : (
                  <S.ActivateButton onClick={onClickActivateCashback} disabled={loadingRedirect}>
                    {loadingRedirect ? (
                      <CircularProgress size={18} color="inherit" />
                    ) : (
                      "Ir para loja"
                    )}
                  </S.ActivateButton>
                )}

                <ModalLogin open={openLoginModal} handleClose={handleCloseLoginModal} />
              </S.CashbackContainer>
              )}
        </FlexContainer>
    </S.HeaderContainerDesktop>
  )
}

export default Header